
const CoinItem = [
    {
        score: 'Basic',
        coin: '1 BTC',
        day: '2 Days'
    },
    {
        score: 'Normal',
        coin: '3 BTC',
        day: '5 Days'
    },
    {
        score: 'Hard',
        coin: '7 BTC',
        day: '10 Days'
    },
]


export default CoinItem